import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

import { Icons } from '../../components/Icon'
import colors from '../../theme/colors'
import { router, routesPath } from '../../router'
import { actions } from '../../redux'

export const useDeclarationComplete = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const quitDeclarationProcess = useCallback(() => {
    dispatch(actions.declaration.setIsInDeclarationProcess(false))
    router(routesPath.userDeclarations)
  }, [dispatch])

  return {
    complete: {
      formLayout: {
        banner: {
          title: t('declaration.complete.banner.title'),
          icon: {
            icon: Icons.check,
            color: colors.pureWhite,
          },
        },
      },
      title: t('declaration.complete.title'),
      text: t('declaration.complete.text'),
      button: {
        text: t('declaration.complete.button.text'),
        href: router(routesPath.userDeclarations),
        onClick: quitDeclarationProcess,
      },
    },
  }
}
